import { http } from '@/network/http';
import type {
  ReportFormData,
  ReportListFilters,
  ReportListResponse,
  Report,
  ReportSummary,
  TreatmentTypeDefinition,
  TreatmentTypeFormData,
  TreatmentTypeListFilters,
  TreatmentTypeListResponse,
  HelmetTypeDefinition,
  HelmetTypeFormData,
  HelmetTypeListFilters,
  HelmetTypeListResponse,
  ReportTypeDefinition,
  ReportTypeFormData,
  ReportTypeListFilters,
  ReportTypeListResponse,
} from './types';

export const reportApi = {
  create: (data: ReportFormData) =>
    http.post<{ success: boolean; report: Report }>('/reports', data),

  getById: (id: string) =>
    http.get<{ success: boolean; report: Report }>(`/reports/${id}`),

  update: (id: string, data: Partial<ReportFormData>) =>
    http.put<{ success: boolean; report: Report }>(`/reports/${id}`, data),

  delete: (id: string) =>
    http.delete<{ success: boolean }>(`/reports/${id}`),

  listMy: (filters?: ReportListFilters) =>
    http.get<ReportListResponse>('/reports/me', { params: filters }),

  listAll: (filters?: ReportListFilters) =>
    http.get<ReportListResponse>('/reports', { params: filters }),

  getSummary: (month?: string) =>
    http.get<{ success: boolean; summary: ReportSummary }>('/reports/summary', {
      params: month ? { month } : undefined,
    }),
};

export const treatmentTypeApi = {
  list: (filters?: TreatmentTypeListFilters) =>
    http.get<TreatmentTypeListResponse>('/treatment-types', { params: filters }),

  getById: (id: string) =>
    http.get<{ success: boolean; treatmentType: TreatmentTypeDefinition }>(`/treatment-types/${id}`),

  create: (data: TreatmentTypeFormData) =>
    http.post<{ success: boolean; treatmentType: TreatmentTypeDefinition }>('/treatment-types', data),

  update: (id: string, data: Partial<TreatmentTypeFormData>) =>
    http.put<{ success: boolean; treatmentType: TreatmentTypeDefinition }>(`/treatment-types/${id}`, data),

  deactivate: (id: string) =>
    http.delete<{ success: boolean }>(`/treatment-types/${id}`),

  setHelmetConnections: (treatmentTypeId: string, helmetTypeIds: string[]) =>
    http.put<{ success: boolean; treatmentType: TreatmentTypeDefinition }>(
      `/treatment-types/${treatmentTypeId}/helmets`,
      { helmetTypeIds },
    ),
};

export const helmetTypeApi = {
  list: (filters?: HelmetTypeListFilters) =>
    http.get<HelmetTypeListResponse>('/helmet-types', { params: filters }),

  getById: (id: string) =>
    http.get<{ success: boolean; helmetType: HelmetTypeDefinition }>(`/helmet-types/${id}`),

  create: (data: HelmetTypeFormData) =>
    http.post<{ success: boolean; helmetType: HelmetTypeDefinition }>('/helmet-types', data),

  update: (id: string, data: Partial<HelmetTypeFormData>) =>
    http.put<{ success: boolean; helmetType: HelmetTypeDefinition }>(`/helmet-types/${id}`, data),

  deactivate: (id: string) =>
    http.delete<{ success: boolean }>(`/helmet-types/${id}`),
};

export const reportTypeApi = {
  list: (filters?: ReportTypeListFilters) =>
    http.get<ReportTypeListResponse>('/report-types', { params: filters }),

  getById: (id: string) =>
    http.get<{ success: boolean; reportType: ReportTypeDefinition }>(`/report-types/${id}`),

  create: (data: ReportTypeFormData) =>
    http.post<{ success: boolean; reportType: ReportTypeDefinition }>('/report-types', data),

  update: (id: string, data: Partial<ReportTypeFormData>) =>
    http.put<{ success: boolean; reportType: ReportTypeDefinition }>(`/report-types/${id}`, data),

  deactivate: (id: string) =>
    http.delete<{ success: boolean }>(`/report-types/${id}`),
};
